import { createSlice } from "@reduxjs/toolkit";
import {
  openDeleteDialog,
  closeDeleteDialog,
  openFillTemplateDialog,
  closeFillTemplateDialog,
  openFilePreviewDialog,
  closeFilePreviewDialog,
  setManagerDrawer,
  setLocationDrawer,
  setClinicianDrawer,
  setSixthFlowPromptsDrawer,
  setSuperbillGoalDrawer,
  setEsignFlowDrawer,
  setAbortController
} from './actions';

export const initialState = {
  deleteDialog: { open: false, type: null, id: null },
  fillTemplateDialog: { open: false },
  filePreviewDialog: { open: false, file: null },
  managerDrawer: { open: false, edit: false },
  locationDrawer: { open: false, edit: false },
  clinicianDrawer: { open: false, edit: false },
  sixthFlowPromptsDrawer: { open: false, edit: false, id: '', title: '', text: '' },
  superbillGoalDrawer: { open: false, edit: false, id: '' },
  esignFlowDrawer: { open: false },
  abortController: null
};

const slice = createSlice({
  name: 'app',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(openDeleteDialog, (state, action) => {
        const { type, id } = action.payload;
        state.deleteDialog = { ...state.deleteDialog, open: true, type, id };
      })
      .addCase(closeDeleteDialog, state => {
        state.deleteDialog = initialState.deleteDialog;
      })
      .addCase(openFillTemplateDialog, state => {
        state.fillTemplateDialog = { ...state.fillTemplateDialog, open: true };
      })
      .addCase(closeFillTemplateDialog, state => {
        state.fillTemplateDialog = initialState.fillTemplateDialog;
      })
      .addCase(openFilePreviewDialog, (state, action) => {
        const file = action.payload;
        state.filePreviewDialog = { ...state.filePreviewDialog, open: true, file };
      })
      .addCase(closeFilePreviewDialog, state => {
        state.filePreviewDialog = initialState.filePreviewDialog;
      })
      .addCase(setManagerDrawer, (state, action) => {
        const { open, edit } = action.payload;
        state.managerDrawer = { ...state.managerDrawer, open, edit };
      })
      .addCase(setLocationDrawer, (state, action) => {
        const { open, edit } = action.payload;
        state.locationDrawer = { ...state.locationDrawer, open, edit };
      })
      .addCase(setClinicianDrawer, (state, action) => {
        const { open, edit } = action.payload;
        state.clinicianDrawer = { ...state.clinicianDrawer, open, edit };
      })
      .addCase(setSixthFlowPromptsDrawer, (state, action) => {
        const { open, edit, id, title, text } = action.payload;
        state.sixthFlowPromptsDrawer = { ...state.sixthFlowPromptsDrawer, open, edit, id, title, text };
      })
      .addCase(setSuperbillGoalDrawer, (state, action) => {
        const { open, edit, id } = action.payload;
        state.superbillGoalDrawer = { ...state.superbillGoalDrawer, open, edit, id };
      })
      .addCase(setEsignFlowDrawer, (state, action) => {
        const { open } = action.payload;
        state.esignFlowDrawer = { ...state.esignFlowDrawer, open };
      })
      .addCase(setAbortController, (state, action) => {
        const abortController = action.payload;
        state.abortController = abortController;
      })
  }
})

export default slice.reducer;
